export type MtoPreserveSkippedLine = {
  itemId?: string;
  payableTaskGroup?: string;
  reasons?: string[];
};

export type MtoPreserveSummary = {
  preservedLineCount?: number;
  skippedLineCount?: number;
  skipped?: MtoPreserveSkippedLine[];
};

/** Append override preserve/skipped detail to an upload/save success toast. */
export function formatMtoPreserveToast(baseMessage: string, summary?: MtoPreserveSummary | null): string {
  const preserved = Number(summary?.preservedLineCount ?? 0);
  const skipped = Number(summary?.skippedLineCount ?? 0);
  if (!preserved && !skipped) return baseMessage;

  let msg = baseMessage;
  if (preserved > 0) {
    msg += ` — preserved ${preserved} line override${preserved === 1 ? '' : 's'}`;
  }
  if (skipped > 0) {
    msg += preserved > 0 ? `; ${skipped} skipped` : ` — ${skipped} line override${skipped === 1 ? '' : 's'} skipped`;
  }
  return msg;
}

/** Short follow-on toast listing skipped item / task groups. */
export function formatMtoPreserveSkippedDetail(summary?: MtoPreserveSummary | null): string | null {
  const skipped = summary?.skipped;
  if (!skipped?.length) return null;
  const labels = skipped.slice(0, 5).map((s) => {
    const item = String(s.itemId || '').trim() || '(unknown item)';
    const task = String(s.payableTaskGroup || '').trim();
    return task ? `${item} / ${task}` : item;
  });
  const more = skipped.length > 5 ? ` (+${skipped.length - 5} more)` : '';
  return `Skipped overrides: ${labels.join('; ')}${more}`;
}

/** Primary success toast + optional skipped-detail toast. */
export function toastMtoPreserveResult(
  toast: (message: string, isError?: boolean) => void,
  baseMessage: string,
  summary?: MtoPreserveSummary | null
) {
  toast(formatMtoPreserveToast(baseMessage, summary));
  const detail = formatMtoPreserveSkippedDetail(summary);
  if (detail) toast(detail);
}
